import { createSelector } from '@reduxjs/toolkit';

import { CmsUserProfileState } from '@definitions/cmsUserProfile.types';

import { GlobalState } from '../createStore';

export const selectCmsUserProfileDomain = (state: GlobalState) => state.cmsUserProfile;

export const selectProfile = createSelector(selectCmsUserProfileDomain, (state: CmsUserProfileState) => state.profile);
